import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { updateCacheByType } from '../../../graphql/GraphQlProvider';
import { GroupMember } from '../../../graphql/groups.datatypes';
import { gqlGroupMember } from '../getGroupMember.api';

interface DeleteGroupMemberInput {
  id: number
}

interface DeleteGroupMemberData {
  deleteGroupMember: GroupMember
}

export const DELETE_GRUOP_MEMBER_MUTATION = gql`
    mutation deleteGroupMember($id: Int!) {
        deleteGroupMember(id: $id) {
            ${gqlGroupMember}
        }
    }
`;

export const deleteGroupMember = () => useMutation<DeleteGroupMemberData, DeleteGroupMemberInput>(
  DELETE_GRUOP_MEMBER_MUTATION,
  {
    update: updateCacheByType('GroupMember'),
  }
);

export default deleteGroupMember;